/** @jsxImportSource @emotion/react */
"use client";

import { SearchIcon } from "../../icons/Icon/TabBarIcons";
import type { InputProps } from "../Input/Input.emotion";
import { Input } from "../Input/Input.emotion";

export type SearchBar = InputProps;

export const SearchBar = ({ ...props }: InputProps) => (
  <Input
    clearable
    closeable
    icon={<SearchIcon.Small />}
    loseFocusOnOutsideClick={false}
    {...props}
  />
);
